import type { SupervisorRun } from '@avisoma/shared';
import { presentSupervisorRun } from '../lib/supervisorRunPresentation';
import { Link } from './Link';
import StatusIndicator from './StatusIndicator';

type Props = { run: SupervisorRun | null | undefined; href?: string };

/**
 * The project-level supervisor stage as one row of the `PageProcessingSummary` grid:
 * label | status + wait/run timings | findings count (linked to `href` when given).
 * The full detail line (counts, coverage, error) is on hover. Renders nothing until a run
 * stamp exists, so the row stays hidden while the supervisor is off.
 */
export function SupervisorStageRow({ run, href }: Props) {
  if (!run) return null;
  const p = presentSupervisorRun(run);
  const count = run.findings !== undefined ? `${run.findings} findings` : '';
  return (
    <div className="grid grid-cols-[110px_1fr_96px] items-center gap-2 text-xs" title={p.detail}>
      <span className="text-gray-700 dark:text-zinc-300">Supervisor</span>
      <span className="flex min-w-0 items-center gap-2 text-gray-700 dark:text-zinc-300">
        <StatusIndicator status={p.indicator} title="Supervisor" className="shrink-0" />
        <span>{p.label}</span>
        {p.timings && <span className="truncate tabular-nums text-gray-500 dark:text-zinc-500">{p.timings}</span>}
      </span>
      <span className="text-right tabular-nums text-gray-600 dark:text-zinc-400">
        {href ? <Link to={href}>{count || 'Corrections'}</Link> : count || '—'}
      </span>
    </div>
  );
}
